module.exports = __webpack_public_path__ + "static/media/lidingshan1.efc8e8aa.jpg";